import React, { useState, useEffect } from 'react';
import './NotificationMarquee.css';

const NotificationMarquee = ({ notification }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (notification) {
      document.body.classList.add('marquee-active');
    }
    return () => document.body.classList.remove('marquee-active');
  }, [notification]);

  if (!isVisible || !notification) return null;

  const message = notification.message || notification.notification || 'No message content.';

  return (
     <div className="wrapper">
    <div className="notification-marquee-container">
      <div className="notification-marquee-content">
        <div className="marquee-text">
          <span>{message}</span>
        </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationMarquee;